import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

import { useImageUploadContext } from '../ImageUploadContext';
import { ImageUploadModal } from '../ImageUploadService';

export const useImageUploadDropdownFocus = (ref: RefObject<HTMLButtonElement | null>) => {
    const { currentModal } = useImageUploadContext();
    const shallFocus = useRef(false);

    useEffect(() => {
        if (currentModal !== ImageUploadModal.None) {
            shallFocus.current = true;
            return;
        }

        if (shallFocus.current) {
            ref.current?.focus();
            shallFocus.current = false;
        }
    }, [currentModal, ref]);
};
